/**
 * TODO Update 'colors.ts' to match new design tokens
 * and deprecate existing colors.
 */
import { lightTheme } from '@unmind/design-system-theme';
import { buttonTheme as buttons } from './buttons';
import { colors } from './unmindColors';

const { colors: lightThemeColors, ...rest } = lightTheme;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  breakpoints: ['48em', '64em', '90em', '120em'],
  buttons,
  colors: {
    success: {
      primary: '#4CAF50',
      background: '#D0F2CF',
      text: '#074C06',
    },
    warning: {
      primary: '#FF9A02',
      background: '#FFE1B3',
    },
    error: {
      primary: '#C01D1D',
      background: '#FFD9D9',
    },
    // raw colors
    ...colors,
    grays: ['#838383', '#9B9B9B', '#C1C1C1', '#E3E3E3', '#F1F1F1', '#F5F5F5', '#F9F9F9'],
    greens: ['#10311D', '#213E2C', '#375844', '#78AC8E', '#CEE1D6', '#f3f7f4'],
    hblues: ['#3AB8C0', '#F0F9Fa'],
    hgreens: ['#60B44C', '#f3f7f4'],
    horanges: ['#ED7D3D', '#FFF5F0'],
    hpinks: ['#9d3591', '#F8EFF7'],
    hpurples: ['#9A2D8D', '#F5ECFD'],
    hyellows: ['#fcb415', '#FFFEEC'],
    purples: ['#706B97', '#8E88B5', '#A8A3CB', '#C8C4E6', '#DFDCF3', '#F1F0F7'],
    oranges: ['#8E4319', '#AA5626', '#C46936', '#E68E5C', '#F6CDB6', '#F9F0EB'],
    olives: ['#60733D', '#80925A', '#ABBD83', '#C7D7A5', '#E2EBCD', '#F4F6EF'],
    reds: ['#90342A', '#B2493E', '#CC5F53', '#E87F74', '#F89F96', '#FFDEDA'],
    sands: ['', '#DAD6D1', '#F5F1E9', '#F9F7F2', '#FBF9F6', '#FEFDFC'],
    teals: ['#4A5F63', '#50737A', '#8EA2A6', '#EAECEC'],
    // TODO Deprecate classic yellow
    yellows: ['#8B601F', '#B9873D', '#D9A454', '#F2BF73', '#FFE9CA', '#FBF6EE'],
    yellowsV2: ['#FFFEE5', '#FFFCBD', '#FFFB96', '#FFFA7D', '#FFF964', '#E3DB29', '#C2BA00', '#817B08', '#363400'],
    whites: ['#FFF', '#F9F9F9'],
    ...lightThemeColors,
  },
  fontSizes: [12, 14, 16, 18, 20, 22, 24, 28, 32, 36, 42],
  fontWeights: [300, 400, 500, 600, 700],
  lineHeights: ['14px', '22px', '33px'],
  mediaQueries: ['(max-width: 768px)', '(max-width: 1024px)', '(max-width: 1440px)', '(max-width: 1920px)'],
  space: [0, 4, 8, 12, 16, 20, 24, 32, 36, 48, 64, 128, 256, 512],
  radii: [0, 2, 4, 8, 12, 16, 24, 36, 64, 128, 256, 512],
  shadows: {
    base: '0px 0px 6px 0px rgba(0,0,0,0.08)',
    dropdown: '0 0 0 1px #E0E0E0,0 5px 20px 0 #151b2614',
    input: 'inset 0px 0px 0px 1px rgba(39, 46, 43, 0.6)',
    inputInset: 'inset 0 0 0 0px #375844',
    inputErrorInset: `inset 0 0 0 0px #98453d`,
  },
  zIndices: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  ...rest,
};
